import { createFileRoute } from '@tanstack/react-router';
import { ConnectionsPage } from '../components/connections-page.js';

export const Route = createFileRoute('/connectors')({
  component: ConnectionsPage,
});
